import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "@/store";
import authorizationUtils from "@/utils/authorization.js";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const isRequireAuth = to.matched.some((record) => record.meta.requiresAuth);
  const permission = to.meta.permission;
  const isSigned = store.getters["Auth/isLoggedIn"];

  if (!to.name) {
    return next("/");
  }

  if (isRequireAuth && !isSigned) {
    return next({
      path: "/login",
      query: {
        redirect: to.path,
      },
    });
  }

  if (isSigned && to.name === "Login") {
    return next("/");
  }

  if (isRequireAuth && isSigned) {
    if (permission && !authorizationUtils.isGranted(permission)) {
      return next("/");
    }
  }

  next();
});

export default router;
